import React, { useContext } from "react";
import { QuizContext } from "../App";
import AuthLogIn from "../components/AuthLogIn";
import AuthSignUp from "../components/AuthSignUp";
// import AuthGetOTP from "../components/PasswordRecoveryGetOTP";
// import AuthNewPassword from "../components/PasswordRecoveryNewPassword";
import AuthSignUpGetOTP from "../components/AuthSignUpGetOTP";

const LogInSignUp = () => {

  const quizContext = useContext(QuizContext);

  return (
    <div className="wrapper">
      {quizContext.state.auth === "signup"
        ? <AuthSignUp />
        : quizContext.state.auth === "getOTP"
          ? <AuthSignUpGetOTP />
          : <AuthLogIn />
      }
    </div>
  )
}

export default LogInSignUp